module.exports = __webpack_public_path__ + "img/plus.24654607.svg";